import mod from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/sport/sport.vue?vue&type=script&lang=js
// module id = uwQL
// module chunks = 37